<template>
  <div class="custom-input">
    <FormulateInput
      v-bind="field"
      :name="field.name"
      type="text"
      :placeholder="field.placeholder"
      :validation="field.validation"
      :error-behavior="field.errorBehavior"
      :value="value"
      @input="$emit('input', $event)"
      @keypress.native="field.handleKeypress"
    >
      <template v-if="field.suffix" #suffix>
        <div class="formulate-input-suffix">
          <span>{{ field.suffix }}</span>
        </div>
      </template>
    </FormulateInput>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'

export default {
  mixins: [Helper],
  props: {
    field: {
      type: Object,
      required: true,
      validator(obj) {
        return ['name', 'placeholder'].every((k) => k in obj)
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  emits: ['input'],
}
</script>

<style lang="scss" scoped>
.custom-input {
  margin-top: 10px;

  &:has(.formulate-input-suffix) {
    :deep(.formulate-input input) {
      border-start-end-radius: 0;
      border-end-end-radius: 0;
    }
  }
}
</style>
